import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../webcomponents.constants';
import { MaintenanceWindowGridGzDataProvider } from '../dataProvider/MaintenanceWindowGridGzDataProvider';

export class MaintenanceWindowGridDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, MaintenanceWindowGridGzDataProvider);
  }
}
